import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DistributorsListView from './Distributors';
import DistributorDetailView from './DistributorDetail';
import MetricsView from './Metrics';
import ResumeView from './Resume';
import ModelsListView from '../catalog/ModelsListView';

const BusinessView = () => (
  <Routes>
    <Route path="business" element={<DistributorsListView />} />
    <Route path="business/:id/models/:brandId" element={<ModelsListView />} />
    <Route path="business/:id/*" element={<DistributorDetailView />} />
    <Route path="business/:id" element={<DistributorDetailView />} />
    <Route path="metrics" element={<MetricsView />} />
    <Route path="resume" element={<ResumeView />} />
    <Route index element={<Navigate to="business" replace />} />
  </Routes>
);

export default BusinessView;
